import Http from '@/utils/request'
import type {
  DistributeSearchResponse,
  FetchDistributeSearchParams,
  FetchHotWordsParams,
  FetchSearchCartoonParams,
  FetchSearchKeywordParams,
  FetchSearchPipeParams,
  SearchCartoonResponse,
  SearchCategoryResponse,
  SearchHotWordsResponse,
  SearchPipeResponse,
  SearchPriorityUserResponse,
  SearchTopicResponse,
  SearchUserResponse,
} from './type'

function normalizePageNo(pageNo: number | undefined) {
  return pageNo && pageNo >= 1 ? pageNo : 1
}

export function fetchSearchCartoons(
  params: FetchSearchCartoonParams,
): Promise<SearchCartoonResponse> {
  return Http({
    url: '/search/cartoon',
    method: 'get',
    params: {
      name: params.name,
      pageNo: normalizePageNo(params.pageNo),
      ...(params.type !== undefined ? { type: params.type } : {}),
      ...(params.eventId !== undefined ? { eventId: params.eventId } : {}),
    },
  })
}

export function fetchSearchPipes(params: FetchSearchPipeParams): Promise<SearchPipeResponse> {
  return Http({
    url: '/search/pipe',
    method: 'get',
    params: {
      userId: params.userId,
      name: params.name,
      pageNo: normalizePageNo(params.pageNo),
      ...(params.eventId !== undefined ? { eventId: params.eventId } : {}),
    },
  })
}

export function fetchSearchUsers(params: FetchSearchKeywordParams): Promise<SearchUserResponse> {
  return Http({
    url: '/search/user',
    method: 'get',
    params: {
      name: params.name,
      pageNo: normalizePageNo(params.pageNo),
      ...(params.eventId !== undefined ? { eventId: params.eventId } : {}),
    },
  })
}

export function fetchSearchTopics(params: FetchSearchKeywordParams): Promise<SearchTopicResponse> {
  return Http({
    url: '/search/topic',
    method: 'get',
    params: {
      name: params.name,
      pageNo: normalizePageNo(params.pageNo),
      ...(params.eventId !== undefined ? { eventId: params.eventId } : {}),
    },
  })
}

export function fetchSearchPriorityUsers(
  params: FetchSearchKeywordParams,
): Promise<SearchPriorityUserResponse> {
  return Http({
    url: '/search/priority/user',
    method: 'get',
    params: {
      name: params.name,
      pageNo: normalizePageNo(params.pageNo),
      ...(params.eventId !== undefined ? { eventId: params.eventId } : {}),
    },
  })
}

export function fetchSearchHotWords(params: FetchHotWordsParams): Promise<SearchHotWordsResponse> {
  return Http({
    url: '/hot/words/list',
    method: 'get',
    params: {
      appearAt: params.appearAt,
      limit: params.limit ?? 10,
    },
  })
}

export function fetchSearchCategories(): Promise<SearchCategoryResponse> {
  return Http({
    url: '/search/category',
    method: 'get',
  })
}

export function fetchDistributeSearch(
  params: FetchDistributeSearchParams,
): Promise<DistributeSearchResponse> {
  return Http({
    url: '/distribute/search',
    method: 'get',
    params: {
      categoryId: params.categoryId,
      pageNo: normalizePageNo(params.pageNo),
    },
  })
}

export type {
  DistributeSearchResponse,
  FetchDistributeSearchParams,
  FetchHotWordsParams,
  FetchSearchCartoonParams,
  FetchSearchKeywordParams,
  FetchSearchPipeParams,
  SearchCartoonItem,
  SearchCartoonResponse,
  SearchCategoryItem,
  SearchCategoryResponse,
  SearchHotWordItem,
  SearchHotWordsResponse,
  SearchPageData,
  SearchPipeResponse,
  SearchPriorityUserItem,
  SearchPriorityUserResponse,
  SearchTopicItem,
  SearchTopicResponse,
  SearchUserItem,
  SearchUserResponse,
  SearchWorkItem,
} from './type'
